import type { CSSProperties, ImgHTMLAttributes } from "react";

type LogoCastieroProps = ImgHTMLAttributes<HTMLImageElement> & {
  transform?: string;
};

const LogoCastiero = ({
  style,
  transform,
  alt = "Castiero",
  ...props
}: LogoCastieroProps) => (
  <img
    {...props}
    alt={alt}
    src="/logo-castiero.png"
    style={{
      objectFit: "contain",
      transform,
      ...(style as CSSProperties | undefined),
    }}
  />
);

export default LogoCastiero;
